<template>
	<div
		:class="$style['skeleton-data-item']"
		:style="styles"
	>
		<div :class="$style['skeleton-data-item__label']" />
		<div :class="$style['skeleton-data-item__value']" />
	</div>
</template>

<script>
export default {
	name: 'SkeletonDataItem',
	props: {
		custom: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		styles () {
			const styles = {}
			return { ...styles, ...this.custom }
		}
	}
}
</script>

<style lang="scss" module>
	$from: getColorStatic(border-image);
	$to: scale-color($from, $lightness: -10%);

	.skeleton-data-item {
		display: flex;
		flex-flow: column;

		&__label {
			height: 16px;
			width: 30%;
			margin-bottom: 5px;
			background-color: getColor(chip-light);
			will-change: opacity;
			animation: pulse 1.2s ease-in-out infinite;
		}

		&__value {
			height: 22px;
			width: 100%;
			background-color: getColor(chip-light);
			will-change: opacity;
			animation: pulse 1.2s ease-in-out infinite 0.1s;
		}
	}

	@keyframes pulse {
		0%, 100% { opacity: 1; }
		50% { opacity: 0.5; }
	}
</style>
